import { FC } from 'react';
import { Container } from './styled';
import Description from '../../../components/Description';
import { QuestSolutionPullRequest, QuestSchema } from 'src/types/quests';
import { PRLink, NoResultsText } from './styled';

interface Props {
    quest: QuestSchema;
}

const QuestSolutionSection: FC<Props> = ({ quest }) => {
    return (
        <Container>
            <Description
                label="Relevant PRs"
                description={
                    <div>
                        {quest.questSolutionPrs &&
                        quest.questSolutionPrs.length > 0 ? (
                            quest.questSolutionPrs.map(
                                (pr: QuestSolutionPullRequest) => (
                                    <PRLink
                                        key={pr.id}
                                        to={pr.prUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {pr.prUrl}
                                    </PRLink>
                                )
                            )
                        ) : (
                            <NoResultsText>No PRs found</NoResultsText>
                        )}
                    </div>
                }
            />
        </Container>
    );
};

export default QuestSolutionSection;
